export const signInUserData = [
    {
        id: '21',
        avatar: '/img/avatars/thumb-1.jpg',
        userName: 'shubham',
        email: 'shubham@shipclues.in',
        authority: ['admin', 'user'],
        password: 'testing@123',
        accountUserName: 'shubham',
    },
]
